<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  (validate)="onValidate($event)"
>
  <div
    class="m-2 before-submit"
    [formGroup]="getControl('data.applicationSignature')"
  >
    <h1 class="section-header">
      {{ "BEFORE_SUBMIT_STATIC_TEXT1" | globalTranslate }}
    </h1>
    <hr />

    @if (!isPresumptive) {
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT3" | globalTranslate }}
    </p>
    }

    <div class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT4" | globalTranslate }}
      <ul class="list-inline">
        <li>{{ "BEFORE_SUBMIT_STATIC_TEXT5" | globalTranslate }}</li>
        <li>{{ "BEFORE_SUBMIT_STATIC_TEXT6" | globalTranslate }}</li>
        <li>{{ "BEFORE_SUBMIT_STATIC_TEXT7" | globalTranslate }}</li>
        <li>{{ "BEFORE_SUBMIT_STATIC_TEXT8" | globalTranslate }}</li>
      </ul>
    </div>
    <br />
    <p class="static-text">
      <b
        ><span class="requiredfd" aria-hidden="true">*</span
        >{{ "BEFORE_SUBMIT_STATIC_TEXT9" | globalTranslate }}</b
      >
    </p>
    <div class="row g-3 py-2">
      <div class="d-flex">
        <label class="radio-inline checkbox" for="voteRegiYesCheck">
          <input
            #checkYes
            [checked]="checkboxValue?.code === 'Y'"
            class="chk-input chk-gap"
            id="voteRegiYesCheck"
            type="radio"
            (change)="voteRegiChecked($event, checkNo)"
            name="voteRegiYesCheck"
            value="Yes"
            required
            aria-required="true"
            aria-invalid="false"
          />
          <label class="chk-lbl">{{ "Yes" | globalTranslate }}</label>
        </label>

        <label class="radio-inline checkbox" for="voteRegiNoCheck">
          <input
            #checkNo
            [checked]="checkboxValue?.code === 'N'"
            class="chk-input chk-gap"
            id="voteRegiNoCheck"
            type="radio"
            (change)="voteRegiChecked($event, checkYes)"
            name="voteRegiNoCheck"
            value="No"
            required
            aria-required="true"
            aria-invalid="false"
          />
          <label class="chk-lbl">{{ "No" | globalTranslate }}</label>
        </label>
      </div>
    </div>

    <p class="static-text">
      {{ "IF_YOU_DONT_MAKE_CHOICE1" | globalTranslate }} <br /><br />
      {{ "IF_YOU_DONT_MAKE_CHOICE2" | globalTranslate }}
    </p>
    <br />

    <div class="row mb-5">
      <div class="col-md-4">
        <a
          class="btn btn-secondary"
          href="https://sos.tn.gov/products/elections/register-vote"
          target="_blank"
          [ngClass]="{ 'height-translate': increaseHeight() }"
          [attr.aria-label]="
            'REGISTER_TO_VOTE_ONLINE_OPENS_NEW_WINDOW' | globalTranslate
          "
          title="Register to Vote Online"
          >{{ "BEFORE_SUBMIT_STATIC_TEXT10" | globalTranslate }}
          <i class="fa fa-external-link" aria-hidden="true"></i
        ></a>
      </div>
    </div>

    <p class="static-text">
      <strong>{{ "BEFORE_SUBMIT_STATIC_TEXT11" | globalTranslate }}</strong>
    </p>
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT12" | globalTranslate }}
    </p>
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT13" | globalTranslate }}
    </p>
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT13_1" | globalTranslate }}
    </p>
    <p class="static-text adjustMargin">
      {{ "BEFORE_SUBMIT_STATIC_TEXT14" | globalTranslate }}
    </p>
    <address>
      <p>
        {{ "DIVISION_OF_ELECTIONS" | translate }}<br />
        {{ "DIVISION_ADDRESS_LINE1" | translate }}<br />
        {{ "DIVISION_ADDRESS_LINE2" | translate }}<br />
        {{ "DIVISION_ADDRESS_LINE3" | translate }}<br />
        <span aria-hidden="true">{{ "OR_CALL" | globalTranslate }}</span
        ><span class="sr-only">{{
          phoneNumberAriaLabel | globalTranslate
        }}</span>
      </p>
    </address>
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT15" | globalTranslate }}
    </p>

    <h2 class="section-header">
      {{ "BEFORE_SUBMIT_STATIC_TEXT16" | globalTranslate }}
    </h2>
    <hr />
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT17" | globalTranslate }}
    </p>

    <p class="static-text">
      <b
        ><span class="requiredfd" aria-hidden="true">*</span
        >{{ "BEFORE_SUBMIT_STATIC_TEXT24" | globalTranslate }}</b
      >
    </p>
    <div class="row g-3 py-2 pb-5 left checkbottom">
      <div class="d-flex">
        <label class="radio-inline checkbox" for="renewCoverageYesCheck">
          <input
            #isrenewcheckYes
            [checked]="isRewCoverageReq?.code === 'Y'"
            class="chk-input chk-gap"
            id="renewCoverageYesCheck"
            type="checkbox"
            (change)="isRenewChecked($event, isrenewcheckNo)"
            name="renewCoverageYesCheck"
            value="Yes"
            required
            aria-required="true"
            aria-invalid="false"
          />
          <label class="chk-lbl">{{ "Yes" | globalTranslate }}</label>
        </label>

        <label class="radio-inline checkbox ms-5" for="renewCoverageNoCheck">
          <input
            #isrenewcheckNo
            [checked]="isRewCoverageReq?.code === 'N'"
            class="chk-input chk-gap"
            id="renewCoverageNoCheck"
            type="checkbox"
            (change)="isRenewChecked($event, isrenewcheckYes)"
            name="renewCoverageNoCheck"
            value="No"
            required
            aria-required="true"
            aria-invalid="false"
          />
          <label class="chk-lbl">{{ "No" | globalTranslate }}</label>
        </label>
      </div>
    </div>

    @if (isrenewcheckYes.checked) {
    <nh-field
      id="st_renewEligibility"
      [label]="permissionLabel | globalTranslate"
      [isRow]="true"
      class="label-section"
    >
      <select
        nhTranslate
        name="renewEligibility"
        class="mt-2 zoom-friendly-select"
        [attr.aria-label]="permissionLabel | globalTranslate"
        [items]="
          tableCodeValue(
            'MPFINISH',
            'data.applicationSignature.renewEligibility'
          )
        "
        formControlName="renewEligibility"
      ></select>
    </nh-field>
    }

    <h2 class="section-header">
      {{ "BEFORE_SUBMIT_STATIC_TEXT27" | globalTranslate }}
    </h2>
    <hr />
    <p class="static-text">
      {{ "BEFORE_SUBMIT_STATIC_TEXT25" | globalTranslate }}
    </p>
    <br />
    <p class="static-text">
      <b>{{ "BEFORE_SUBMIT_STATIC_TEXT28" | globalTranslate }}</b>
    </p>
    <div class="row g-3 py-2 pb-2 left">
      <div class="d-flex">
        <label class="radio-inline checkbox" for="renewCoverageAVSYesCheck">
          <input
            #isrenewAVScheckYes
            [checked]="isavsConsentValue?.code === 'Y'"
            class="chk-input chk-gap"
            id="renewCoverageAVSYesCheck"
            type="checkbox"
            (change)="isRenewCheckedAVS($event, isrenewAVScheckNo)"
            name="renewCoverageAVSYesCheck"
            value="Yes"
          />
          <label class="chk-lbl">{{ "Yes" | globalTranslate }}</label>
        </label>

        <label class="radio-inline checkbox ms-5" for="renewCoverageAVSNoCheck">
          <input
            #isrenewAVScheckNo
            [checked]="isavsConsentValue?.code === 'N'"
            class="chk-input chk-gap"
            id="renewCoverageAVSNoCheck"
            type="checkbox"
            (change)="isRenewCheckedAVS($event, isrenewAVScheckYes)"
            name="renewCoverageAVSNoCheck"
            value="No"
          />
          <label class="chk-lbl">{{ "No" | globalTranslate }}</label>
        </label>
      </div>
    </div>
    <br />
    <div
      class="static-text"
      [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT26' | globalTranslate"
    ></div>

    @if (!this.mcoMasterSwitch) {
    <div>
      @if (showHealthPlan) {
      <div>
        <h2 class="section-header">
          {{ "BEFORE_SUBMIT_STATIC_TEXT18" | globalTranslate }}
        </h2>
        <hr />
        <p
          class="static-text"
          [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT19' | globalTranslate"
        ></p>
        <nh-field
          id="st_healthPlan"
          label="{{ 'BEFORE_SUBMIT_STATIC_TEXT20' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
          class="label-section"
        >
          <select
            nhTranslate
            name="healthPlan"
            aria-label="healthPlan"
            [items]="
              tableCodeValue('MCONAME', 'data.applicationSignature.healthPlan')
            "
            formControlName="healthPlan"
          ></select>
        </nh-field>
        <p
          class="static-text"
          [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT21' | globalTranslate"
        ></p>
        <p
          class="static-text"
          [innerHTML]="'BEFORE_SUBMIT_STATIC_TEXT23' | globalTranslate"
        ></p>
      </div>
      }
    </div>
    }
  </div>
</nh-form>